import echarts from 'echarts'
import moment from 'moment'

const mount  =  (params) =>{
  return  moment(params).format('YYYY-MM-DD')
}
const install = function(Vue) {
    Object.defineProperties(Vue.prototype, {
        $chart: {
            get() {
                return {
                    //画一条简单的线
                    line1: function (id,data) {
                        let time = []
                        let uvValue = []
                        let pvValue = []
                        let starValue = []
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        data.dwellTimeList.forEach(item => {
                            time.push(mount(item.time))
                        });
                        data.uvList.forEach(item =>{
                            uvValue.push(item.value)
                        })
                        data.startupPagePvList.forEach(item =>{
                            pvValue.push(item.value)
                        })
                        data.startupPageClickList.forEach(item =>{
                            starValue.push(item.value)
                        })
                        
                        
                        // for (let index = 0; index < dataa.time.length; index++) {
                        //   arr.push(dataa.time[index])
                        // }
                       
                        const optionData = {
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data:    time       ,     //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                            },
                            legend: {
                                data:['pv','uv','启动量']
                            },
                            
                            tooltip : {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    label: {
                                        backgroundColor: '#6a7985'
                                    }
                                },
                                feature: {
                                    dataZoom: {
                                        yAxisIndex: 'none'
                                    },
                                    restore: {},
                                    saveAsImage: {}
                                }
                                
                            },
                            dataZoom: [
                                {
                                    id: 'dataZoomX',
                                    type: 'slider',
                                    xAxisIndex: [0],
                                    filterMode: 'filter'
                                },
                               
                            ],
                            yAxis: {
                                minInterval : 1,
                                type: 'value',
                                position:'left',
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                                splitLine: {     //网格线
                             boundaryGap : [ 0, 0.5 ],
                              lineStyle:{
                                color:'rgb(227,227,227)',
                                width: 1,
              
                                }

                                  },                         
                            },
                            splitLine: {
                                lineStyle: {
                                    // 使用深浅的间隔色
                                    color: ['#aaa', '#ddd']
                                }
                            },
                            series: [
                                {
                                    name:'pv',
                                    data: pvValue,
                                    type: 'line',
                                    smooth: true,
                                    color:'rgb(85,132,208)',
                                    
                                },
                                {
                                    name:'uv',
                                    type:'line',
                                    stack: '总量',
                                    smooth: true,
                                    data:uvValue
                                },
                                {
                                    name:'启动量',
                                    type:'line',
                                    stack: '总量',
                                    smooth: true,
                                    data:starValue
                                },
                                
                               
                            ]
                           
                        };

                        this.chart.setOption(optionData);
                    },
                    line2: function (id,data) {
                        let time = []
                        let uvValue = []
                        let pvValue = []
                        let starValue = []
                        let miniApp = []
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        data.dwellTimeList.forEach(item => {
                            time.push(mount(item.time))
                        });
                        data.uvList.forEach(item =>{
                            uvValue.push(item.value)
                        })
                        data.startupPagePvList.forEach(item =>{
                            pvValue.push(item.value)
                        })
                        data.startupPageClickList.forEach(item =>{
                            starValue.push(item.value)
                        })
                        data.miniAppPvList.forEach(item =>{
                            miniApp.push(item.value)
                        })
                        
                        // for (let index = 0; index < dataa.time.length; index++) {
                        //   arr.push(dataa.time[index])
                        // }
                       
                        const optionData = {
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data:    time       ,     //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                            },
                            legend: {
                                data:['pv','uv',]
                            },
                            dataZoom: [
                                {
                                    id: 'dataZoomX',
                                    type: 'slider',
                                    xAxisIndex: [0],
                                    filterMode: 'filter'
                                },
                               
                            ],
                            tooltip : {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    label: {
                                        backgroundColor: '#6a7985'
                                    }
                                }
                            },
                            yAxis: {
                                type: 'value',
                                position:'left',
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                                splitLine: {     //网格线
                              
                              lineStyle:{
                                color:'rgb(227,227,227)',
                                width: 1,
              
                                }

                                  },                         
                            },
                            splitLine: {
                                lineStyle: {
                                    // 使用深浅的间隔色
                                    color: ['#aaa', '#ddd']
                                }
                            },
                            series: [
                                {
                                    name:'pv',
                                    data: miniApp,
                                    type: 'line',
                                    smooth: true,
                                    color:'rgb(85,132,208)',
                                },
                                {
                                    name:'uv',
                                    type:'line',
                                    stack: '总量',
                                    smooth: true,
                                    data:uvValue
                                },
                              
                               
                            ]
                           
                        };

                        this.chart.setOption(optionData);
                    },
                    line3: function (id,data) {
                        let time = []
                        let value = []
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        data.dwellTimeList.forEach(item => {
                            time.push(mount(item.time))
                            value.push(item.value)
                        });
                        console.log(value)
                        function formatSeconds(value) {
                            if (value<=0) {
                                value =  Math.abs(value)
                            }
                            var secondTime = parseInt(value);// 秒
                            var minuteTime = 0;// 分
                            var hourTime = 0;// 小时
                            // if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
                            //     //获取分钟，除以60取整数，得到整数分钟
                            //     minuteTime = parseInt(secondTime / 60);
                            //     //获取秒数，秒数取佘，得到整数秒数
                            //     secondTime = parseInt(secondTime % 60);
                            //     //如果分钟大于60，将分钟转换成小时
                                
                            // }
                            var result = "" + parseInt(secondTime) ;
                            return result;
                        }
                        
                        // for (let index = 0; index < dataa.time.length; index++) {
                        //   arr.push(dataa.time[index])
                        // }
                       
                        const optionData = {
                            xAxis: {
                                type: 'category',
                                boundaryGap: true,
                                data:    time       ,     //['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                            },
                            dataZoom: [
                                {
                                    id: 'dataZoomX',
                                    type: 'slider',
                                    xAxisIndex: [0],
                                    filterMode: 'filter'
                                },
                               
                            ],
                            legend: {
                                data:['停留时长']
                            },
                            tooltip : {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    label: {
                                        backgroundColor: '#6a7985'
                                    }
                                }
                            },
                            yAxis: {
                                type: 'value',
                                position:'left',
                                axisLine:{       //y轴
                                    show:true
                          
                                  },
                                  axisTick:{       //y轴刻度线
                                    show:true
                                  },
                                splitLine: {     //网格线
                              
                              lineStyle:{
                                color:'rgb(227,227,227)',
                                width: 1,
              
                                }

                                  },                         
                            },
                            splitLine: {
                                lineStyle: {
                                    // 使用深浅的间隔色
                                    color: ['#aaa', '#ddd']
                                }
                            },
                            series: [
                                {
                                    name:'停留时长',
                                    data: value,
                                    type: 'line',
                                    smooth: true,
                                    color:'rgb(85,132,208)',
                                },
                              
                               
                            ]
                           
                        };

                        this.chart.setOption(optionData);
                    },
                    myChart: function(id){
                        this.chart = echarts.init(document.getElementById(id));
                        this.chart.clear();
                        const option = {
                            color: ['#487ACC', '#6CCE82', '#EEDD58', '#E477A2', '#E8A35C', '#8CE6DE'],
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b}: {c} ({d}%)"
                            },
                            legend: {
                                type: 'scroll',
                                orient: 'vertical',
                                left: 80,
                                top: 50,
                                bottom: 20,
                                itemWidth: 24,   // 设置图例图形的宽
                                itemHeight: 18,
                                itemGap: 30,
                                data:['LINK','EOS','PNT','HT','CVT']
                            },
                            series: [
                                {
                                    name:'访问来源',
                                    type:'pie',
                                    radius: ['20%', '80%'],
                                    center: ['70%', '50%'],
                                    itemStyle: {
                                        emphasis: {
                                            shadowBlur: 10,
                                            shadowOffsetX: 0,
                                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                                        }
                                    },
                                    data:[
                                        {value:1548, name:'LINK'},
                                        {value:310, name:'EOS'},
                                        {value:234, name:'PNT'},
                                        {value:135, name:'HT'},
                                        {value:335, name:'CVT'}
                                    ]
                                }
                            ]
                        };
                        this.chart.setOption(option);
                    }
                }
            }
        }
    })
}

export default {
    install
}